<template>
	<PopUp
		title="Zugangsdaten (Link) senden"
		size="lg"
		ok-text="Senden"
		:ok-disabled="!linkValid || sending"
		:ok-loading="sending"
		:closable="!sending"
		@ok="send"
		@hidden="$emit('hidden')"
	>
		<div>
			Sende dem Kandidaten rechtzeitig die Zugangsdaten die er für einen Video-Call und/oder eine Onlinetätigkeit
			benötigt.
		</div>
		<FormGroup
			label="Zugangsdaten (Link)"
			:state="linkValid"
			:invalid-feedback="linkError"
			feedback-beneath
			class="mt-4"
		>
			<b-input v-model="link" />
		</FormGroup>
		<b-row class="mt-4">
			<b-col md="6">
				<FormGroup label="Benutzername (optional)">
					<b-input v-model="username" />
				</FormGroup>
			</b-col>
			<b-col md="6">
				<FormGroup label="Passwort (optional)">
					<b-input v-model="password" />
				</FormGroup>
			</b-col>
		</b-row>
	</PopUp>
</template>

<script>
import PopUp from "@/vue/common/PopUp";
import FormGroup from "@/vue/common/form/Group";
import {isDefined} from "@/helper/Value";
import {isEmptyOrNull, stringOrNull} from "@/helper/String";
import {isValid} from "@/helper/validation/Url";
import Modify, {ACTION_SEND_ACCESS_LINK} from "@/api/communication/appointment/Modify";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import {error} from "@/helper/Log";

export default {

	components: {
		PopUp,
		FormGroup,
	},

	props: {
		appointment: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			link: this.appointment.accessLink || '',
			username: this.appointment.accessLinkUsername || '',
			password: this.appointment.accessLinkPassword || '',
			sending: false,
		};
	},

	computed: {
		linkValid ()
		{
			return !isDefined(this.linkError);
		},
		linkError ()
		{
			if (isEmptyOrNull(this.link))
			{
				return 'Pflichtfeld';
			}

			if (!isValid(this.link))
			{
				return 'Der Link muss mit http:// oder https:// beginnen';
			}

			return null;
		},
	},

	methods: {
		async send ()
		{
			this.sending = true;

			try
			{
				await new Modify()
					.setAppointmentId(this.appointment.id)
					.setAction(ACTION_SEND_ACCESS_LINK)
					.setAccessLink(this.link)
					.setAccessLinkUsername(stringOrNull(this.username))
					.setAccessLinkPassword(stringOrNull(this.password))
					.call();

				Toast.success(this, ['Zugangsdaten erfolgreich verschickt']);

				this.$emit('sent');
			}
			catch (e)
			{
				await error(e);

				Toast.error(this, flatten(e.errors));
			}

			this.sending = false;
		}
	}
}
</script>
